module.exports = __webpack_public_path__ + "static/media/bg-texture-2.290a9223.png";